import { render, staticRenderFns } from "./ElementStudioAction.vue?vue&type=template&id=8fcac5b6&"
import script from "./ElementStudioAction.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioAction.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioAction.vue?vue&type=style&index=0&id=8fcac5b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports